module.exports = __webpack_public_path__ + "img/Posada-cabo_0005_pool1.061f1c2f.jpg";